import React, { Fragment, useEffect, useRef, useState } from "react";
import { Select as AntSelect, Dropdown, Menu } from "antd";
import { CaretDownOutlined } from "@ant-design/icons";
import {
  Card,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TextField,
  CircularProgress,
  Checkbox,
  Dialog,
  Button,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import "./EmissionMetric.scss";
import { useNavigate, useParams } from "react-router-dom";
import {
  CATEGORY_CODE,
  STEPS,
  TARGET_REDUCER_TYPES,
  TARGET_TYPES,
} from "../../constants/enums";
import { useTranslation } from "react-i18next";
import { getAllUomsService } from "../../services/emissionService";
import { ArrowLeft, ArrowRight, Delete, Remove } from "@mui/icons-material";

const EmissionMetric = (props: any) => {
  const { t, i18n } = useTranslation();
  enum Metrics {
    ACTIVE_EMPLOYEES,
    GROSS_FLOOR_AREA,
    ANNUAL_REVENUE,
    TARGET_NO_OF_UNITS,
  }
  const {
    setStep,
    dispatch,
    setIsSubmit,
    targetState,
    categoryList,
    uomMap,
    setUOMMap,
    setIsUpdate,
    baseValues,
    targetValues,
    netValues,
    isLoading,
    selectedIndex,
    isMetricsAdded,
    setIsMetricsAdded,
    // switchStates,
  } = props;

  const [isSaveEnabled, setIsSaveEnabled] = useState(true);
  const { Option } = AntSelect;
  const { id } = useParams();
  let isEdit = !!id;
  const netZeroTarget = targetState.targets?.find(
    (eachTarget: any) => eachTarget.type === TARGET_TYPES.NET_ZERO
  );
  const targetYears = targetState.targets?.filter(
    (eachTarget: any) => eachTarget.type === TARGET_TYPES.TARGET
  );
  const baselineYears = targetState.targets?.filter(
    (eachTarget: any) => eachTarget.type === TARGET_TYPES.BASELINE
  );

  const getUomName = (symbol: string) => {
    const parts = symbol?.split("/");
    if (parts?.length > 1) {
      return parts[parts?.length - 1];
    } else {
      return symbol;
    }
  };

  // const updateMetric = (
  //   updateType: String,
  //   type: String,
  //   year: number,
  //   value?: string,
  //   percent?: string
  // ) => {
  //   dispatch({
  //     type: TARGET_REDUCER_TYPES.UPDATE_TARGET_METRIC,
  //     payload: {
  //       type: type,
  //       year: year,
  //       value: value,
  //       percent: percent,
  //       isUpdated: isEdit ? true : false,
  //     },
  //   });
  // };
  const onChange = (
    index: number,
    updateType: String,
    type: String,
    year: number,
    categoryId?: number,
    value?: string,
    percent?: string,
    baseLineYear?: number,
    intensity?: string,
    rowIdx?: number
  ) => {
    let isValidated = true;
    const scope =
      selectedIndex === 1 && rowIdx === 1
        ? rowIdx + 2
        : rowIdx
        ? rowIdx + 1
        : 1;
    setIsSaveEnabled(isValidated);
    dispatch({
      type: TARGET_REDUCER_TYPES.UPDATE_TARGET_METRIC,
      payload: {
        type: type,
        year: year,
        value: value,
        percent: percent,
        isUpdated: true,
        baseLineYear: baseLineYear,
        categoryId: categoryId,
        intensity: intensity,
        scope: scope,
      },
    });
  };

  const updateMetrics = async (values: any, targets: any) => {
    console.log(targetState.targets);
    for (const eachBaseline of values) {
      for (const eachMetric of eachBaseline.metrics) {
        await dispatch({
          type: TARGET_REDUCER_TYPES.UPDATE_TARGET_METRIC,
          payload: {
            type: eachMetric.type,
            year: eachBaseline.target_year,
            value: eachMetric.value,
            id: eachMetric.id,
            percent: eachMetric.percent,
            intensity: eachMetric.intensity,
            rowIdx: eachBaseline.target_scope
              ? selectedIndex === 1 && eachBaseline.target_scope === 3
                ? eachBaseline.target_scope - 2
                : eachBaseline.target_scope - 1
              : 0,
            scope: eachBaseline.target_scope ? eachBaseline.target_scope : 1,
            categoryId:
              selectedIndex === 3 ? eachBaseline?.emissions[0].category : 0,
            isUpdated: true,
          },
        });
      }
    }
    for (const eachTarget of targets) {
      for (const eachMetric of eachTarget.metrics) {
        await dispatch({
          type: TARGET_REDUCER_TYPES.UPDATE_TARGET_METRIC,
          payload: {
            type: eachMetric.type,
            year: eachTarget.target_year,
            value: eachMetric.value,
            id: eachMetric.id,
            percent: eachMetric.percent,
            intensity: eachMetric.intensity,
            isCustom: eachMetric.is_custom,
            uom: eachMetric.uom,
            uomSymbol: eachMetric.uom_name,
            rowIdx: eachTarget.target_scope
              ? selectedIndex === 1 && eachTarget.target_scope === 3
                ? eachTarget.target_scope - 2
                : eachTarget.target_scope - 1
              : 0,
            scope: eachTarget.target_scope ? eachTarget.target_scope : 1,
            categoryId:
              selectedIndex === 3 ? eachTarget?.emissions[0].category : 0,
            isUpdated: true,
          },
        });
      }
    }
    // for (const eachMetric of zerovalues[0]?.metrics) {
    //   if (zerovalues[0].year) {
    //     await dispatch({
    //       type: TARGET_REDUCER_TYPES.UPDATE_TARGET_METRIC,
    //       payload: {
    //         type: eachMetric.type,
    //         year: values[0].year,
    //         value: eachMetric.value,
    //         id: eachMetric.id,
    //         percent: eachMetric.percent,
    //         intensity: eachMetric.intensity,
    //         isCustom: eachMetric.is_custom,
    //         uom: eachMetric.uom,
    //         uomSymbol: eachMetric.uom_name,
    //       },
    //     });
    //   }
    // }
  };

  useEffect(() => {
    const addMetrics = () => {
      if (isEdit) {
        let values = baseValues;
        setIsUpdate(isEdit);

        values.forEach((eachBaseline: any) => {
          const row = eachBaseline.target_scope
            ? selectedIndex === 1 && eachBaseline.target_scope === 3
              ? eachBaseline.target_scope - 2
              : eachBaseline.target_scope - 1
            : 0;
          const categoryId =
            selectedIndex === 3 ? eachBaseline?.emissions[0].category : 0;

          eachBaseline.metrics.forEach((eachMetric: any, index: any) => {
            if (eachMetric.is_custom) {
              setIntensityUOM(eachMetric.uom_name);
              handleTableCellItems(
                selectedIndex >= 3 ? 2 : selectedIndex,
                row,
                categoryId,
                eachMetric.type,
                eachMetric.uom_name,
                eachMetric.uom
              );
            } else {
              const itemIndex = dropDownItems.findIndex(
                (item) =>
                  item.label === metricsInverseAttributes[eachMetric.type]
              );
              handleCheckboxChange(itemIndex, row, categoryId);
            }
          });
        });
      }
    };

    addMetrics();
  }, [baseValues, targetValues, netValues, isEdit, selectedIndex]);

  useEffect(() => {
    let intervalId: string | number | NodeJS.Timer | undefined;

    const checkMetricsAdded = () => {
      const baselineTargets = targetState.targets.filter(
        (target: { type: TARGET_TYPES }) =>
          target.type === TARGET_TYPES.BASELINE
      );
      let allMetricsLengthMatch = false;

      for (const eachTarget of baselineTargets) {
        const matchingValue = baseValues.find(
          (value: { target_id: any }) => value.target_id === eachTarget.id
        );
        if (
          matchingValue &&
          eachTarget.metrics.length === matchingValue.metrics.length
        ) {
          allMetricsLengthMatch = true;
          break;
        }
      }

      if (allMetricsLengthMatch) {
        clearInterval(intervalId);
        updateMetrics(baseValues, targetValues);
        setIsMetricsAdded(false);
      }
    };

    if (isMetricsAdded) {
      intervalId = setInterval(checkMetricsAdded, 1000);
    }

    return () => clearInterval(intervalId);
  }, [isMetricsAdded, targetState.targets, baseValues]);

  const navigate = useNavigate();

  const metricsInverseAttributes: any = {
    ACTIVE_EMPLOYEES: "Active employees",
    GROSS_FLOOR_AREA: "Gross floor area",
    ANNUAL_REVENUE: "Annual revenue",
    ECONOMIC_INTENSITY: "Economic intensity",
    TARGET_NO_OF_UNITS: "Target no. of units",
  };

  let uomChanged = false;
  const changeUoms = (e: any, eachCell: any) => {
    uomChanged = true;
    let uomsMap = uomMap;
    let uom = uomsMap[eachCell].uoms.find(
      (eachMetric: any) => eachMetric.id === e
    );
    uomsMap[eachCell].uom = e;
    uomsMap[eachCell].uomSymbol = uom.symbol;

    setUOMMap({ ...uomsMap });
  };
  const filterUnits = (label: any, input: String) => {
    return (label.toString().toLowerCase() ?? "").includes(
      input.toString().toLowerCase()
    );
  };
  const checkMinus = (e: any) => {
    if (e?.code === "Minus") {
      e.preventDefault();
    }
  };

  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleClose = () => {
    setDropdownOpen(false);
  };

  const dropDownItems: DropDownItem[] = [
    {
      index: 0,
      label: "Add Custom metric",
      uom: "",
      uomID: 0,
      selected: false,
    },
    {
      index: 1,
      label: "Active employees",
      uom: "t CO2e/Employee",
      uomID: 65,
      selected: false,
    },
    {
      index: 2,
      label: "Gross floor area",
      uom: "t CO2e/Acres",
      uomID: 66,
      selected: false,
    },
    {
      index: 3,
      label: "Economic intensity",
      uom: "t CO2e/USD",
      uomID: 70,
      selected: false,
    },
    {
      index: 4,
      label: "Target no. of units",
      uom: "t CO2e/Units",
      uomID: 74,
      selected: false,
    },
  ];

  const [uomMapInitialized, setUomMapInitialized] = useState(false);

  useEffect(() => {
    if (!uomMapInitialized) {
      let uomsMap = { ...uomMap };
      dropDownItems.forEach((item) => {
        let uom = uomsMap[item.index]?.uoms?.find(
          (eachMetric: { id: number }) => eachMetric.id === item.uomID
        );
        if (uom) {
          uomsMap[item.index] = {
            ...uomsMap[item.index],
            uom: item.uomID,
            uomSymbol: uom.symbol,
          };
        }
      });

      setUOMMap(uomsMap);
      setUomMapInitialized(true);
    }
  }, [dropdownOpen, uomMap, uomChanged]);

  const [items, setItems] = useState(dropDownItems);

  type DropDownItem = {
    index: number;
    label: string;
    uom: string;
    uomID: number;
    selected: boolean;
  };

  type ItemsByRow = {
    [idx: number]: DropDownItem[];
  };
  const [values, setValues] = useState<ItemsByRow>({});

  const [valuesByCategory, setValuesByCategory] = useState<ItemsByRow>({});

  const [valuesUpdated, setValuesUpdated] = useState(false);

  const handleCheckboxChange = (
    index: number,
    rowIdx: number,
    categoryId: number
  ) => {
    const key =
      selectedIndex >= 3 // && !switchStates[TARGET_TYPES.BASELINE]?.[rowIdx]
        ? categoryId
        : rowIdx;
    const updateValues = (prevItems: ItemsByRow) => {
      if (!prevItems[key]) {
        prevItems[key] = dropDownItems;
      }
      const updatedItems = prevItems[key].map((item) => {
        if (item.index === index) {
          const updatedItem = { ...item, selected: !item.selected };
          if (updatedItem.selected) {
            addMetric(
              updatedItem.label,
              0,
              updatedItem.uom,
              updatedItem.uomID,
              item.index > 4 ? true : false,
              rowIdx,
              categoryId
            );
          } else {
            removeMetric(updatedItem.label, rowIdx, categoryId);
          }
          return updatedItem;
        }
        return item;
      });

      return {
        ...prevItems,
        [key]: updatedItems,
      };
    };

    if (selectedIndex >= 3) {
      //&& !switchStates[TARGET_TYPES.BASELINE]?.[rowIdx]) {
      setValuesByCategory((prevItems) => updateValues(prevItems));
      // setValues((prevItems) => updateValues(prevItems));
      setValuesUpdated(false);
    } else {
      setValues((prevItems) => updateValues(prevItems));
      setValuesUpdated(true);
    }
  };

  const handleTableCellItems = (
    rows: number,
    rowIdx: number,
    categoryId: number,
    type: string,
    uomName: string,
    uom: number
  ) => {
    addMetric(type, 0, uomName, uom, true, rowIdx, categoryId);
    setValues((prevItems) => {
      const newItems = { ...prevItems };
      for (let idx = 0; idx <= rows; idx++) {
        if (!newItems[idx]) {
          newItems[idx] = dropDownItems;
        }
      }
      for (let idx = 0; idx <= rows; idx++) {
        newItems[idx] = [
          ...newItems[idx],
          {
            index: newItems[idx].length,
            label: type,
            uom: uomName,
            uomID: uom,
            selected: idx === rowIdx ? true : false,
          },
        ];
      }

      console.log("newItems", newItems);

      return newItems;
    });

    setValuesByCategory((prevItems) => {
      const newItems = { ...prevItems };

      filteredCategories.forEach((category: any) => {
        const idx = category.id;
        if (!newItems[idx]) {
          newItems[idx] = dropDownItems;
        }
      });

      filteredCategories.forEach((category: any) => {
        const idx = category.id;
        newItems[idx] = [
          ...newItems[idx],
          {
            index: newItems[idx].length,
            label: type,
            uom: uomName,
            uomID: uom,
            selected: idx === categoryId ? true : false,
          },
        ];
      });

      return newItems;
    });
  };

  const [OpenMetricDialog, setOpenMetricDialog] = useState(false);
  const [dialogRowIdx, setDialogRowIdx] = useState<number>(0);
  const [dialogCatId, setDialogCatId] = useState<number>(0);

  const handleMetricDialog = (rowIdx: number, categoryId: number) => {
    fetchUoms();
    setDialogRowIdx(rowIdx);
    setDialogCatId(categoryId);
    setOpenMetricDialog(true);
  };
  const handleDialogClose = () => {
    setOpenMetricDialog(false);
  };

  // const selectedItems = items.filter((item) => item.selected === true);

  const [selectedItemsByRow, setSelectedItemsByRow] = useState<{
    [idx: number]: DropDownItem[];
  }>({});
  const [selectedItemsByCategory, setSelectedItemsByCategory] = useState<{
    [idx: number]: DropDownItem[];
  }>({});

  useEffect(() => {
    let activeValues = valuesUpdated ? values : valuesByCategory;
    const selectedItems = Object.entries(activeValues).reduce(
      (acc, [idx, items]) => {
        const filteredItems = items.filter((item) => item.selected === true);
        if (filteredItems.length > 0) {
          acc[Number(idx)] = filteredItems;
        }
        return acc;
      },
      {} as { [year: number]: DropDownItem[] }
    );
    valuesUpdated
      ? setSelectedItemsByRow(selectedItems)
      : setSelectedItemsByCategory(selectedItems);
  }, [
    values,
    setValues,
    setDropdownOpen,
    valuesByCategory,
    setValuesByCategory,
  ]);

  const addMetric = (
    type: string,
    value: any,
    uomSymbol: any,
    uomID: number,
    isCustom: boolean,
    rowIdx: number,
    categoryId: number
  ) => {
    let netZero = netValues[0]?.metrics?.find((eachMetric: any) =>
      isCustom
        ? eachMetric.type === type
        : metricsInverseAttributes[eachMetric.type] === type
    );
    dispatch({
      type: TARGET_REDUCER_TYPES.ADD_METRICS,
      payload: {
        metrics: [
          {
            type: type,
            value: value,
            uom: uomID,
            uomSymbol: uomSymbol,
            isCustom: isCustom,
            rowIdx: rowIdx,
            categoryId: categoryId,
            netZeroId: isEdit ? netZero?.id : null,
          },
        ],
      },
    });
  };
  const removeMetric = (type: string, rowIdx: number, categoryId: number) => {
    dispatch({
      type: TARGET_REDUCER_TYPES.REMOVE_METRICS,
      payload: {
        metrics: [
          {
            type: type,
            rowIdx: rowIdx,
            categoryId: categoryId,
          },
        ],
      },
    });
  };

  const [uomList, setUomList] = useState<
    { id: number; name: string; symbol: string }[]
  >([]);

  const fetchUoms = async () => {
    try {
      const res = await getAllUomsService();
      let formattedData: { id: number; name: string; symbol: string }[] = [];
      res.data.forEach((each: any) => {
        if (each.symbol.startsWith("t CO2e/")) {
          formattedData.push({
            id: each.id,
            name: each.name,
            symbol: each.symbol,
          });
        }
      });
      setUomList(formattedData);
    } catch (error) {
      console.error("Error fetching UoMs:", error);
    }
  };

  // const cellWidth =
  //   selectedItems.length > 0 ? `${550 / selectedItems.length}px` : "auto";

  const [intensityName, setIntensityName] = useState("");
  const [intensityUOM, setIntensityUOM] = useState("");
  const [intensityUOMId, setIntensityUOMId] = useState(0);
  const [uomName, setUomName] = useState("");
  const [storedValues, setStoredValues] = useState({});

  const handleSelectionChange = (value: string) => {
    setIntensityUOM(value);
    const selectedUOM = uomList.filter(
      (uom: { symbol: string }) => uom.symbol === value
    );
    selectedUOM.forEach((uom: { symbol: string; id: number; name: string }) => {
      setIntensityUOM(uom.symbol);
      setIntensityUOMId(uom.id);
    });
    if (intensityName && intensityUOM) {
      setStoredValues({ intensityName, intensityUOM });
    }
  };

  const [metricData, setMetricData] = useState(new Map());

  const handleMetricData = (rowIdx: number, categoryId: number) => {
    if (intensityName && intensityUOM) {
      const index = metricData.size;
      const newEntry = { name: intensityName, uom: intensityUOM };
      setMetricData(new Map(metricData.set(index, newEntry)));
      setIntensityName("");
      setIntensityUOM("");
      handleDialogClose();
      setUOMMap((prevUOMMap: any) => ({
        ...prevUOMMap,
        [intensityName]: {
          uoms: [],
          uom: intensityUOMId,
          uomSymbol: intensityUOM,
        },
      }));
      setValues((prevItems: ItemsByRow) => {
        if (!prevItems[rowIdx]) {
          prevItems[rowIdx] = dropDownItems;
        }
        return {
          ...prevItems,
        };
      });
      handleTableCellItems(
        selectedIndex >= 3 ? 2 : selectedIndex,
        rowIdx,
        categoryId,
        intensityName,
        intensityUOM,
        intensityUOMId
      );
    }
  };

  const [openDropdown, setOpenDropdown] = useState<Record<number, boolean>>({});

  const handleDropdownToggle = (rowIdx: number) => {
    setOpenDropdown((prev) => ({
      ...prev,
      [rowIdx]: !prev[rowIdx],
    }));
  };

  const [editCustomMetric, setEditCustomMetric] = useState(false);
  const [mertricRowIdx, setMetricRowIdx] = useState(0);
  const [canEdit, setCanEdit] = useState(true);

  const handleEditCustomMetric = (index: number, rowIdx: number) => {
    setEditCustomMetric(true);
    setCanEdit(false);
    setIntensityName(values[rowIdx][index]?.label);
    setIntensityUOM(values[rowIdx][index]?.uom);
    setMetricRowIdx(rowIdx);
    setOpenMetricDialog(true);
  };

  type CurrentCategoryIdx = {
    [type: string]: {
      [rowIdx: number]: number;
    };
  };
  const [currentCategoryIdx, setCurrentCategoryIdx] =
    useState<CurrentCategoryIdx>({
      BASELINE: { 0: 0, 1: 0, 2: 0 },
      TARGET: { 0: 0, 1: 0, 2: 0 },
    });

  type FilteredCategoriesByRow = {
    [type: string]: {
      [rowIdx: number]: any[];
    };
  };

  const [filteredCategoriesByRow, setFilteredCategoriesByRow] =
    useState<FilteredCategoriesByRow>({
      BASELINE: {},
      TARGET: {},
    });

  const shouldDisplayCategory = (code: CATEGORY_CODE, scope: number) => {
    if (scope === 1) {
      return (
        code >= CATEGORY_CODE.CATEGORY_1_1 && code < CATEGORY_CODE.CATEGORY_2_1
      );
    } else if (scope === 2) {
      return (
        code >= CATEGORY_CODE.CATEGORY_2_1 && code < CATEGORY_CODE.CATEGORY_3_1
      );
    } else if (scope === 3) {
      return code >= CATEGORY_CODE.CATEGORY_3_1;
    }
  };

  const handleNextClick = (rowIdx: number, type: string) => {
    setCurrentCategoryIdx((prevState) => ({
      ...prevState,
      [type]: {
        ...prevState[type],
        [rowIdx]: (prevState[type][rowIdx] ?? 0) + 1,
      },
    }));
  };

  const handlePrevClick = (rowIdx: number, type: string) => {
    setCurrentCategoryIdx((prevState) => ({
      ...prevState,
      [type]: {
        ...prevState[type],
        [rowIdx]: (prevState[type][rowIdx] ?? 0) - 1,
      },
    }));
  };

  const categories = categoryList || [];

  const filteredCategories = categories.filter((category: any) => {
    const baseline = baselineYears.find(
      (baseline: { rowIdx: number; categoryId: number; included: boolean }) =>
        baseline.categoryId === category.id && baseline.included
    );
    return baseline !== undefined;
  });

  const renderBaselineTable = (count: number) => {
    const displayContent = (rowIdx: number) => {
      if (selectedIndex === 0) {
        if (selectedIndex === 0) {
          return "Baseline Year";
        }
      } else if (selectedIndex === 1) {
        return rowIdx === 0
          ? "Baseline year Scope 1 & 2"
          : "Baseline year Scope 3";
      } else {
        return rowIdx === 0
          ? "Baseline year Scope 1"
          : rowIdx === 1
          ? "Baseline year Scope 2"
          : "Baseline year Scope 3";
      }
      return "";
    };
    return (
      <>
        {[...Array(count)].map((_, rowIdx) => {
          filteredCategoriesByRow[TARGET_TYPES.BASELINE][rowIdx] =
            filteredCategories.filter((eachCategory: any) =>
              shouldDisplayCategory(eachCategory.code, rowIdx + 1)
            );

          const currentCategory =
            selectedIndex >= 3 //!switchStates[TARGET_TYPES.BASELINE]?.[rowIdx]
              ? filteredCategoriesByRow[TARGET_TYPES.BASELINE]?.[rowIdx]?.[
                  currentCategoryIdx[TARGET_TYPES.BASELINE]?.[rowIdx]
                ] ?? -1
              : -1;
          const relevantBaseline = baselineYears?.find(
            (baseline: { rowIdx: number; categoryId: number }) =>
              baseline.rowIdx === rowIdx &&
              (selectedIndex < 3
                ? true
                : baseline.categoryId === currentCategory?.id)
          );

          const selectedItems =
            selectedIndex >= 3 // && !switchStates[TARGET_TYPES.BASELINE]?.[rowIdx]
              ? selectedItemsByCategory[currentCategory?.id]
              : selectedItemsByRow[rowIdx];

          const dropdownContent = (currentRowIdx: number) => {
            if (currentRowIdx !== rowIdx) {
              setDropdownOpen(false);
              return null;
            }
            const itemsToDisplay =
              values[currentRowIdx]?.length ||
              valuesByCategory[currentCategory?.id]?.length
                ? selectedIndex >= 3
                  ? // && !switchStates[TARGET_TYPES.BASELINE]?.[rowIdx]
                    valuesByCategory[currentCategory?.id]
                  : values[currentRowIdx]
                : dropDownItems;

            return (
              <Menu>
                {itemsToDisplay?.map((item) => (
                  <Menu.Item key={item.index}>
                    {item.index === 0 ? (
                      <div
                        style={{ display: "flex", alignItems: "center" }}
                        onClick={(e) => {
                          handleMetricDialog(rowIdx, currentCategory?.id);
                        }}
                      >
                        <img
                          src="assets/icons/addIcon.svg"
                          className="cursor-pointer ml-2"
                          alt="Add icon"
                        />
                        <span style={{ marginLeft: "12px", color: "#59ce90" }}>
                          {item.label}
                        </span>
                      </div>
                    ) : (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <Checkbox
                          size="small"
                          checked={item.selected}
                          onChange={() => {
                            handleCheckboxChange(
                              item.index,
                              rowIdx,
                              currentCategory?.id
                            );
                          }}
                        />
                        <span style={{ marginLeft: "8px" }}>{item.label}</span>
                      </div>
                    )}
                  </Menu.Item>
                ))}
              </Menu>
            );
          };

          return (
            <React.Fragment key={rowIdx}>
              <Table size="small" className="pw-activity-table">
                <TableHead className="pw-activity-table-head">
                  <TableRow>
                    <TableCell className="pw-activity-list w-[205px]">
                      {t(displayContent(rowIdx))}
                    </TableCell>
                    {selectedItems?.length ? (
                      selectedItems?.map((item) => (
                        <TableCell
                          key={item.index}
                          className={`pw-activity-list `}
                          align="left"
                          style={{ width: `${550 / selectedItems.length}px` }}
                        >
                          <div className="flex flex-col">
                            <div style={{ position: "relative" }}>
                              {/* {item.index > 4 ? (
                                <Button
                                  onClick={() =>
                                    handleEditCustomMetric(item.index, rowIdx)
                                  }
                                  className=""
                                  style={{
                                    position: "absolute",
                                    right: "0px",
                                    zIndex: 1,
                                  }}
                                >
                                  <CreateIcon className="pw-bunit-edit-icon text-neutral-600" />
                                </Button>
                              ) : (
                                ""
                              )} */}
                              <div>{item.label}</div>
                            </div>
                            {item.index > 1 && item.index < 5 ? (
                              <AntSelect
                                suffixIcon={
                                  <CaretDownOutlined className="!pointer-events-none" />
                                }
                                popupClassName="pw-metrics-uom-dropdown"
                                id="pw-metric-uom"
                                showSearch
                                style={{ width: 100 }}
                                className="pw-source-select"
                                placeholder="Select"
                                value={uomMap[item.label].uom}
                                onChange={(e) => changeUoms(e, item.label)}
                              >
                                {uomMap[item.label]?.uoms?.map(
                                  (eachUOM: any) => (
                                    <Option
                                      key={eachUOM.id}
                                      value={eachUOM.id}
                                      className="pw-menu-item"
                                    >
                                      {eachUOM?.symbol?.split("/")[1]}
                                    </Option>
                                  )
                                )}
                              </AntSelect>
                            ) : (
                              ""
                            )}
                            <div>
                              {isEdit ? item.uom : uomMap[item.label].uomSymbol}
                            </div>
                          </div>
                        </TableCell>
                      ))
                    ) : (
                      <TableCell
                        className="pw-activity-list w-[552px]"
                        align="right"
                      >
                        <div className="flex flex-row justify-center">
                          <span className="pw-padding-right-20">
                            {" "}
                            {(selectedIndex >= 3 && currentCategory !== -1) ||
                            selectedIndex < 3
                              ? `${t("Add or select metrics of your choice")} `
                              : ""}
                          </span>
                          <span className="pw-padding-top-3">
                            {(selectedIndex >= 3 && currentCategory !== -1) ||
                            selectedIndex < 3 ? (
                              <Dropdown
                                dropdownRender={() => dropdownContent(rowIdx)}
                                open={!!openDropdown[rowIdx]}
                                onOpenChange={(open) =>
                                  handleDropdownToggle(rowIdx)
                                }
                              >
                                <span
                                  onClick={() => handleDropdownToggle(rowIdx)}
                                >
                                  <img
                                    src="assets/icons/addIcon.svg"
                                    className="cursor-pointer"
                                    alt="Add icon"
                                  />
                                </span>
                              </Dropdown>
                            ) : null}
                          </span>
                        </div>
                      </TableCell>
                    )}
                    {selectedItems?.length ? (
                      <TableCell
                        style={{
                          marginLeft: "0.7rem",
                          marginTop: "18px",
                          position: "relative",
                        }}
                      >
                        <Dropdown
                          dropdownRender={() => dropdownContent(rowIdx)}
                          open={!!openDropdown[rowIdx]}
                          onOpenChange={(open) => handleDropdownToggle(rowIdx)}
                        >
                          <span onClick={() => handleDropdownToggle(rowIdx)}>
                            <img
                              src="assets/icons/addIcon.svg"
                              className="cursor-pointer"
                              alt="Add icon"
                            />
                          </span>
                        </Dropdown>
                      </TableCell>
                    ) : (
                      ""
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {selectedIndex >= 3 && currentCategory !== -1 ? (
                    // && !switchStates[TARGET_TYPES.BASELINE]?.[rowIdx] ? (
                    <TableRow>
                      <TableCell colSpan={3}>
                        {currentCategory?.code} {currentCategory?.name}
                      </TableCell>
                    </TableRow>
                  ) : null}
                  {(selectedIndex >= 3 && currentCategory !== -1) ||
                  selectedIndex < 3 ? (
                    <>
                      <TableRow>
                        <TableCell rowSpan={2} style={{ border: "none" }}>
                          <TableRow>
                            <TableCell rowSpan={2} className="w-[58px]">
                              {relevantBaseline?.year}
                            </TableCell>
                            <TableCell>Activity Output</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>Intensity</TableCell>
                          </TableRow>
                        </TableCell>
                        {selectedItems?.length
                          ? // relevantBaseline?.metrics?.length
                            selectedItems.map((selectedItem, index) => {
                              const matchedMetric =
                                relevantBaseline.metrics.find(
                                  (eachMetric: any) =>
                                    metricsInverseAttributes[
                                      eachMetric.type
                                    ] === selectedItem.label ||
                                    eachMetric.type === selectedItem.label
                                );
                              return matchedMetric ? (
                                <TableCell key={matchedMetric.type}>
                                  <TextField
                                    onKeyDown={checkMinus}
                                    id="pw-baseline-metrics-input"
                                    className="pw-baseline-metric-input"
                                    variant="standard"
                                    sx={{ input: { textAlign: "left" } }}
                                    placeholder=""
                                    value={matchedMetric.value}
                                    onChange={(e) =>
                                      onChange(
                                        index,
                                        TARGET_TYPES.BASELINE,
                                        matchedMetric.type,
                                        relevantBaseline.year,
                                        currentCategory?.id || -1,
                                        e.target.value,
                                        undefined,
                                        undefined,
                                        undefined,
                                        rowIdx
                                      )
                                    }
                                  />
                                </TableCell>
                              ) : (
                                ""
                              );
                            })
                          : ""}
                      </TableRow>
                      <TableRow>
                        {selectedItems?.length
                          ? selectedItems.map((selectedItem) => {
                              const metric = relevantBaseline?.metrics?.find(
                                (eachMetric: any) =>
                                  metricsInverseAttributes[eachMetric.type] ===
                                    selectedItem.label ||
                                  eachMetric.type === selectedItem.label
                              );
                              return metric ? (
                                <TableCell
                                  key={metric.type}
                                  align="left"
                                  className="pw-baseline-intensity"
                                >
                                  {metric?.intensity || 0}
                                  {isEdit
                                    ? selectedItem.uom
                                    : uomMap[selectedItem.label]?.uomSymbol}
                                </TableCell>
                              ) : (
                                ""
                              );
                            })
                          : ""}
                      </TableRow>
                    </>
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={
                          selectedItems != null && selectedItems?.length
                            ? selectedItems?.length + 1
                            : 1
                        }
                        align="center"
                      >
                        Baseline year not defined
                      </TableCell>
                      {/* <TableCell></TableCell> */}
                    </TableRow>
                  )}
                  {selectedIndex !== null &&
                  selectedIndex >= 3 &&
                  currentCategory !== -1 ? (
                    // !switchStates[TARGET_TYPES.BASELINE]?.[rowIdx] ? (
                    <TableRow className="navigation-row">
                      <TableCell
                        colSpan={6}
                        className="pw-activity-list bg-neutral-50 pw-navigation-container"
                      >
                        <div className="pw-navigation-content">
                          {currentCategoryIdx[TARGET_TYPES.BASELINE]?.[rowIdx] >
                            0 && (
                            <div className="flex flex-row gap-2">
                              <div className="text-primary">
                                Previous Category
                              </div>
                              <div
                                onClick={() =>
                                  handlePrevClick(rowIdx, TARGET_TYPES.BASELINE)
                                }
                                className="pw-navigate-next pw-padding-5"
                              >
                                <ArrowLeft />
                              </div>
                            </div>
                          )}
                          {currentCategoryIdx[TARGET_TYPES.BASELINE]?.[rowIdx] <
                            filteredCategoriesByRow[TARGET_TYPES.BASELINE][
                              rowIdx
                            ].length -
                              1 && (
                            <div className="flex flex-row ml-auto gap-2">
                              <div className="text-primary">Next Category</div>
                              <div
                                onClick={() =>
                                  handleNextClick(rowIdx, TARGET_TYPES.BASELINE)
                                }
                                className="pw-navigate-next pw-padding-5"
                              >
                                <ArrowRight />
                              </div>
                            </div>
                          )}
                        </div>
                      </TableCell>
                    </TableRow>
                  ) : null}
                </TableBody>
              </Table>
            </React.Fragment>
          );
        })}
      </>
    );
  };

  const renderTargetTable = (count: number) => {
    const displayContent = (rowIdx: number) => {
      if (selectedIndex === 0) {
        return "Target Year";
      } else if (selectedIndex === 1) {
        return rowIdx === 0 ? "Target year Scope 1 & 2" : "Target year Scope 3";
      } else {
        return rowIdx === 0
          ? "Target year Scope 1"
          : rowIdx === 1
          ? "Target year Scope 2"
          : "Target year Scope 3";
      }
    };

    return (
      <>
        {[...Array(count)].map((_, rowIdx) => {
          const isLastRow = rowIdx === count - 1;

          // const relevantBaseline = baselineYears?.find(
          //   (baseline: { rowIdx: number }) => baseline.rowIdx === rowIdx
          // );

          filteredCategoriesByRow[TARGET_TYPES.TARGET][rowIdx] =
            filteredCategories.filter((eachCategory: any) =>
              shouldDisplayCategory(eachCategory.code, rowIdx + 1)
            );

          const currentCategory =
            filteredCategoriesByRow[TARGET_TYPES.TARGET]?.[rowIdx]?.[
              currentCategoryIdx[TARGET_TYPES.TARGET]?.[rowIdx]
            ] ?? null;

          // const relevantBaseline = baselineYears?.find(
          //   (baseline: { rowIdx: number; categoryId: number }) =>
          //     baseline.rowIdx === rowIdx && selectedIndex < 3
          //       ? true
          //       : baseline.categoryId === currentCategory.id ||
          //         baseline.categoryId === -1
          // );

          const relevantBaseline = baselineYears?.find(
            (baseline: { rowIdx: number; categoryId: number }) =>
              baseline.rowIdx === rowIdx &&
              (selectedIndex < 3
                ? true
                : baseline.categoryId === currentCategory?.id)
          );

          const targetYrs = targetYears.filter(
            (targetYr: { rowIdx: any; categoryId: any }) =>
              targetYr.rowIdx === rowIdx &&
              (selectedIndex < 3
                ? true
                : targetYr.categoryId === currentCategory?.id)
            // || targetYr.categoryId === -1)
          );

          const selectedItems =
            selectedIndex >= 3 // && !switchStates[TARGET_TYPES.BASELINE]?.[rowIdx]
              ? selectedItemsByCategory[currentCategory?.id]
              : selectedItemsByRow[rowIdx];

          return (
            <div
              key={rowIdx}
              className={`flex flex-col ${
                isLastRow ? "" : "pb-10 bg-neutral-100"
              }`}
            >
              <Card>
                <Table size="small" className="pw-activity-table">
                  <TableHead className="pw-activity-table-head">
                    <TableRow>
                      <TableCell className="pw-activity-list w-[205px]">
                        {t("Projection for ") + displayContent(rowIdx)}
                      </TableCell>
                      {selectedItems?.length ? (
                        selectedItems?.map((item) => {
                          const matchedMetric = relevantBaseline?.metrics?.find(
                            (eachMetric: any) =>
                              metricsInverseAttributes[eachMetric.type] ===
                              item.label
                          );

                          return (
                            <TableCell
                              key={item.index}
                              className={`pw-activity-list`}
                              align="left"
                              style={{
                                width: `${550 / selectedItems?.length}px`,
                              }}
                            >
                              <div className="flex flex-col">
                                {item.index === 3
                                  ? `${item.label} ratio`
                                  : `${item.label} intensity ratio`}
                                {
                                  <div>
                                    {isEdit
                                      ? item.uom
                                      : uomMap[item.label]?.uomSymbol}
                                  </div>
                                }
                              </div>
                            </TableCell>
                          );
                        })
                      ) : (
                        <TableCell
                          className="pw-activity-list w-[552px]"
                          align="left"
                        ></TableCell>
                      )}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {selectedIndex >= 3 && currentCategory ? (
                      // !switchStates[TARGET_TYPES.TARGET]?.[rowIdx] ? (
                      <TableRow>
                        <TableCell colSpan={3}>
                          {currentCategory?.code} {currentCategory?.name}
                        </TableCell>
                      </TableRow>
                    ) : (
                      ""
                    )}
                    {targetYrs?.length ? (
                      targetYrs.map((eachTarget: any) => (
                        <div className="contents" key={eachTarget.year}>
                          <TableRow>
                            <TableCell
                              rowSpan={3}
                              style={{ padding: "0", margin: "0" }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  width: "100%",
                                  height: "100%",
                                  padding: "0",
                                  margin: "0",
                                }}
                              >
                                <div
                                  style={{ width: "58px", marginTop: "32px" }}
                                >
                                  {eachTarget.year}
                                </div>
                                <div
                                  style={{
                                    width: "147px",
                                    padding: "5px",
                                    margin: "-0.85rem",
                                  }}
                                >
                                  <div className="p-2">Activity Output</div>
                                  <div className="p-2">% reduction</div>
                                  <div className="p-2">Intensity</div>
                                </div>
                              </div>
                            </TableCell>
                            {selectedItems?.length ? (
                              selectedItems?.map((item: any, index: number) => {
                                const matchedMetric = eachTarget?.metrics?.find(
                                  (eachMetric: any) =>
                                    metricsInverseAttributes[
                                      eachMetric.type
                                    ] === item.label ||
                                    eachMetric.type === item.label
                                );
                                return (
                                  <TableCell key={item.index} align="left">
                                    {/* {selectedItems?.length &&
                            eachTarget?.metrics?.length ? (
                              selectedItems.map((selectedItem, index) => {
                                const matchedMetric = eachTarget.metrics.find(
                                  (eachMetric: any) =>
                                    metricsInverseAttributes[
                                      eachMetric.type
                                    ] === selectedItem.label ||
                                    eachMetric.type === selectedItem.label
                                );
                                return matchedMetric ? (
                                  <TableCell
                                    key={matchedMetric.type}
                                    align="left"
                                  > */}
                                    <div className="flex flex-col">
                                      <div className="flex flex-row gap-1">
                                        <TextField
                                          onKeyDown={checkMinus}
                                          className="pw-target-metrics-value"
                                          variant="standard"
                                          id="pw-target-metrics-value"
                                          placeholder=""
                                          value={matchedMetric?.value || ""}
                                          sx={{
                                            input: { textAlign: "right" },
                                          }}
                                          onChange={(e: any) =>
                                            onChange(
                                              index,
                                              TARGET_TYPES.TARGET,
                                              matchedMetric?.type,
                                              eachTarget.year,
                                              currentCategory?.id || -1,
                                              e.target.value,
                                              undefined,
                                              relevantBaseline.year,
                                              undefined,
                                              rowIdx
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                  </TableCell>
                                );
                              })
                            ) : (
                              <TableCell
                                align="right"
                                colSpan={selectedItems?.length || 1}
                              ></TableCell>
                            )}
                            {/* </TableCell>
                                ) : null;
                              })
                            ) : (
                              <TableCell
                                align="right"
                                colSpan={selectedItems?.length || 1}
                              ></TableCell>
                            )} */}
                          </TableRow>
                          <TableRow>
                            {selectedItems?.length ? (
                              selectedItems?.map((item: any, index: number) => {
                                const matchedMetric = eachTarget?.metrics?.find(
                                  (eachMetric: any) =>
                                    metricsInverseAttributes[
                                      eachMetric.type
                                    ] === item.label ||
                                    eachMetric.type === item.label
                                );
                                return (
                                  <TableCell key={item.index} align="left">
                                    <div className="flex flex-col">
                                      <div className="flex flex-row gap-1">
                                        <TextField
                                          onKeyDown={checkMinus}
                                          className="pw-target-metrics-value"
                                          variant="standard"
                                          id="pw-target-metrics-value"
                                          placeholder=""
                                          value={matchedMetric?.percent || ""}
                                          sx={{
                                            input: { textAlign: "right" },
                                          }}
                                          onChange={(e: any) =>
                                            onChange(
                                              index,
                                              TARGET_TYPES.TARGET,
                                              matchedMetric?.type,
                                              eachTarget.year,
                                              currentCategory?.id || -1,
                                              undefined,
                                              e.target.value,
                                              relevantBaseline.year,
                                              undefined,
                                              rowIdx
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                  </TableCell>
                                );
                              })
                            ) : (
                              <TableCell
                                align="right"
                                colSpan={selectedItems?.length || 1}
                              ></TableCell>
                            )}
                          </TableRow>
                          <TableRow>
                            {selectedItems?.length ? (
                              selectedItems?.map((item: any, index: number) => {
                                const matchedMetric = eachTarget?.metrics?.find(
                                  (eachMetric: any) =>
                                    metricsInverseAttributes[
                                      eachMetric.type
                                    ] === item.label ||
                                    eachMetric.type === item.label
                                );
                                return (
                                  <TableCell key={item.index} align="left">
                                    <div className="flex flex-col">
                                      <div className="flex flex-row gap-1">
                                        <TextField
                                          onKeyDown={checkMinus}
                                          className="pw-target-metrics-value"
                                          variant="standard"
                                          id="pw-target-metrics-value"
                                          placeholder=""
                                          value={matchedMetric?.intensity || ""}
                                          sx={{
                                            input: { textAlign: "right" },
                                          }}
                                          onChange={(e: any) =>
                                            onChange(
                                              index,
                                              TARGET_TYPES.TARGET,
                                              matchedMetric?.type,
                                              eachTarget.year,
                                              currentCategory?.id || -1,
                                              undefined,
                                              undefined,
                                              relevantBaseline.year,
                                              e.target.value,
                                              rowIdx
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                  </TableCell>
                                );
                              })
                            ) : (
                              <TableCell
                                align="right"
                                colSpan={selectedItems?.length || 1}
                              ></TableCell>
                            )}
                          </TableRow>
                        </div>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell
                          colSpan={
                            selectedItems != null && selectedItems?.length
                              ? selectedItems?.length + 1
                              : 1
                          }
                          align="center"
                        >
                          {currentCategory ? "Target" : "Baseline"} year not
                          defined
                        </TableCell>
                        <TableCell></TableCell>
                      </TableRow>
                    )}
                    {selectedIndex !== null &&
                    selectedIndex >= 3 &&
                    currentCategory ? (
                      // !switchStates[TARGET_TYPES.TARGET]?.[rowIdx] ? (
                      <TableRow className="navigation-row">
                        <TableCell
                          colSpan={6}
                          className="pw-activity-list bg-neutral-50 pw-navigation-container"
                        >
                          <div className="pw-navigation-content">
                            {currentCategoryIdx[TARGET_TYPES.TARGET]?.[rowIdx] >
                              0 && (
                              <div className="flex flex-row gap-2">
                                <div className="text-primary">
                                  Previous Category
                                </div>
                                <div
                                  onClick={() =>
                                    handlePrevClick(rowIdx, TARGET_TYPES.TARGET)
                                  }
                                  className="pw-navigate-next pw-padding-5"
                                >
                                  <ArrowLeft />
                                </div>
                              </div>
                            )}
                            {currentCategoryIdx[TARGET_TYPES.TARGET]?.[rowIdx] <
                              filteredCategoriesByRow[TARGET_TYPES.TARGET][
                                rowIdx
                              ].length -
                                1 && (
                              <div className="flex flex-row ml-auto gap-2">
                                <div className="text-primary">
                                  Next Category
                                </div>
                                <div
                                  onClick={() =>
                                    handleNextClick(rowIdx, TARGET_TYPES.TARGET)
                                  }
                                  className="pw-navigate-next pw-padding-5"
                                >
                                  <ArrowRight />
                                </div>
                              </div>
                            )}
                          </div>
                        </TableCell>
                      </TableRow>
                    ) : null}
                  </TableBody>
                </Table>
              </Card>
            </div>
          );
        })}
      </>
    );
  };

  return (
    <Fragment>
      <div className="pw-activity-data-main w-55v overflow-y-auto flex flex-col gap-10">
        <div>
          <div className="pw-input-label pw-create-label">{t("Metrics")}</div>
          <div className="flex flex-row justify-between items-center pw-border-bottom pb-2">
            <div className="flex flex-row gap-1">
              <p className="text-sm text-neutral-600"></p>
            </div>
          </div>
        </div>
        <div>
          <div className="pw-range-label pb-1.5 text-neutral-600">
            {t("Facility")}
          </div>
          <AntSelect
            suffixIcon={<CaretDownOutlined className="!pointer-events-none" />}
            dropdownStyle={{ minWidth: "25%" }}
            showSearch
            style={{ width: 300 }}
            className="pw-metric-bunit-select"
            placeholder="Select"
            value={targetState.businessUnit}
            disabled
          >
            <Option
              key={targetState.businessUnit}
              value={targetState.businessUnit}
              className="pw-menu-item"
            >
              {targetState?.businessUnitName}
            </Option>
          </AntSelect>
        </div>

        <div>
          <Card>
            {selectedIndex >= 2 ? (
              <>{renderBaselineTable(3)}</>
            ) : selectedIndex === 1 ? (
              <>{renderBaselineTable(2)}</>
            ) : (
              <>{renderBaselineTable(1)}</>
            )}
          </Card>
        </div>

        <div>
          <Card>
            {selectedIndex >= 2 ? (
              <>{renderTargetTable(3)}</>
            ) : selectedIndex === 1 ? (
              <>{renderTargetTable(2)}</>
            ) : (
              <>{renderTargetTable(1)}</>
            )}
          </Card>
        </div>
        <div>
          <Card>
            <Table size="small" className="pw-activitydata-table">
              <TableHead className="pw-activity-table-head bg-neutral-50">
                <TableRow>
                  <TableCell className="pw-activity-list">
                    {t("Net zero year")}
                  </TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell className=" w-[205px]">
                    {netZeroTarget.year}
                  </TableCell>
                  <TableCell className=" w-[550px]">0</TableCell>
                </TableRow>
                {/* {selectedItems.length && netZeroTarget?.metrics?.length
                    ? netZeroTarget.metrics.map(
                        (eachMetric: any, index: number) => {
                          const matchedItem = selectedItems.find(
                            (item) => item.label === eachMetric.type
                          );
                          return matchedItem ? (
                            <TableCell key={eachMetric.type}>
                              <TextField
                                onKeyDown={checkMinus}
                                id="pw-baseline-metrics-input"
                                className="pw-baseline-metric-input"
                                variant="standard"
                                sx={{ input: { textAlign: "left" } }}
                                placeholder=""
                                value={eachMetric.value}
                                onChange={(e: any) =>
                                  onChange(
                                    index,
                                    "netZero",
                                    eachMetric.type,
                                    netZeroTarget.year,
                                    e.target.value,
                                    undefined,
                                    undefined,
                                    undefined
                                  )
                                }
                              />
                            </TableCell>
                          ) : (
                            ""
                          );
                        }
                      )
                    : ""} */}
              </TableBody>
            </Table>
          </Card>
        </div>
      </div>

      <div className="flex flex-row justify-end pw-bunit-footer w-full gap-6">
        <div
          className="pw-bunit-button-light pw-bunit-button-next text-neutral bg-white font-bold cursor-pointer"
          onClick={() => navigate("/targets")}
        >
          {t("Cancel")}
        </div>
        <div
          className="pw-bunit-button-light pw-bunit-button-next text-neutral bg-white font-bold  cursor-pointer"
          onClick={() => setStep(STEPS.EMISSION_TARGET)}
        >
          {t("Back")}
        </div>
        <button
          className={`pw-bunit-button-primary pw-bunit-button-save text-white ${
            isSaveEnabled
              ? isLoading
                ? "text-black bg-neutral-300"
                : "cursor-pointer bg-primary"
              : "text-black bg-neutral-300"
          }`}
          onClick={() => isSaveEnabled && setIsSubmit(true)}
          disabled={!isSaveEnabled}
        >
          {isLoading ? (
            <div className="flex flex-row gap-2 p-2">
              <span>{t("Saving up")}</span>
              <CircularProgress size={20} />
            </div>
          ) : (
            <span>{t("Save")}</span>
          )}
        </button>
      </div>
      {OpenMetricDialog && (
        <Dialog
          className="pw-metric-dialog"
          open={OpenMetricDialog}
          onClose={handleDialogClose}
        >
          <div className="p-3.5 pl-7">
            <div className="flex flex-row justify-between pb-7">
              <div className="text-neutral-900 pw-dialog-header">
                <div>Add custom metric</div>
              </div>
              <div className="flex flex-row gap-3">
                {/* {editCustomMetric ? (
                  <>
                    <div>
                      <Button
                        onClick={() =>
                          //canEdit = true
                          setCanEdit(true)
                        }
                        className="pw-editbox-emission"
                      >
                        <CreateIcon className="pw-bunit-edit-icon text-neutral-600" />
                        <div className="pw-edit">Edit</div>
                      </Button>
                    </div>
                    <div
                      onClick={(e) => {
                        removeMetric(intensityName, mertricRowIdx);
                        setValues((prevItems) => {
                          return {
                            ...prevItems,
                            [mertricRowIdx]: prevItems[mertricRowIdx].filter(
                              (item) => item.label !== intensityName
                            ),
                          };
                        });
                        handleDialogClose();
                        setIntensityName("");
                        setIntensityUOM("");
                        setEditCustomMetric(false);
                      }}
                      style={{
                        cursor: "pointer",
                        textAlign: "right",
                      }}
                    >
                      <Delete sx={{ color: "#d96a61" }} />
                    </div>
                  </>
                ) : (
                  ""
                )} */}
                <div
                  onClick={handleDialogClose}
                  style={{
                    cursor: "pointer",
                    textAlign: "right",
                  }}
                >
                  <CancelIcon />
                </div>
              </div>
            </div>
            <div>
              <div className="pb-2.5 text-neutral-600 text-xs">
                {t("Intensity Name")}
              </div>
              <TextField
                style={{ width: 350 }}
                placeholder={t("Intensity Name")}
                size="small"
                value={intensityName}
                onChange={(e) => setIntensityName(e.target.value)}
                disabled={isEdit || !canEdit}
              />
            </div>
            <div className="p-2"></div>
            <div>
              <div className="pb-2.5 text-neutral-600 text-xs">
                {t("Intensity UOM")}
              </div>
              <div>
                <AntSelect
                  suffixIcon={
                    <CaretDownOutlined className="!pointer-events-none" />
                  }
                  dropdownStyle={{ minWidth: "25%" }}
                  showSearch
                  style={{ width: 350 }}
                  className="pw-source-select"
                  placeholder={t("Select unit")}
                  onChange={handleSelectionChange}
                  popupClassName="pw-target-bunit-dropdown"
                  id="pw-target-bunit"
                  filterOption={(input, option) =>
                    filterUnits(option?.label, input)
                  }
                  disabled={isEdit || !canEdit}
                  getPopupContainer={(trigger) => trigger.parentElement}
                  value={intensityUOM}
                >
                  {uomList.map(({ name, id, symbol }) => (
                    <AntSelect.Option key={id} value={symbol}>
                      {symbol}
                    </AntSelect.Option>
                  ))}
                </AntSelect>
              </div>
            </div>
            <div
              className="flex flex-row justify-end pw-bunit-footer w-full gap-6"
              style={{ position: "absolute", bottom: "0", left: "0" }}
            >
              <div
                className="pw-bunit-button-light pw-bunit-button-next text-neutral bg-white font-bold"
                onClick={handleDialogClose}
              >
                {t("Cancel")}
              </div>
              <button
                className={`pw-bunit-button-primary pw-bunit-button-save text-white ${
                  intensityName && intensityUOM && canEdit
                    ? "bg-primary"
                    : "bg-neutral-200 cursor-not-allowed"
                }`}
                onClick={() => handleMetricData(dialogRowIdx, dialogCatId)}
              >
                {t("Save")}
              </button>
            </div>
          </div>
        </Dialog>
      )}
    </Fragment>
  );
};

export default EmissionMetric;
